import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY } from "../../../base";
import Endpoints from "../../../domain/endpoints";
import Swal from "sweetalert2";
import { RejectCustomer } from "../../../domain/useages/customer-database/reject-customer";
import { RemoteRejectCustomer } from "../../../data/usecases/customer-database/remote-reject-customer";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

export interface RejectCustomerInterface {
  rejectCustomer: Function;
  handleRejectLoading: Function;
}

const initialStates = {};

const axiosHttpClient = AxiosHttpClient.getInstance();

export const useRejectCustomerSlice: StateCreator<RejectCustomerInterface> = (
  set,
  get
) => ({
  ...initialStates,
  handleRejectLoading: (value: boolean) => {
    if (value) {
      Swal.fire({
        didOpen: () => {
          if (value) {
            Swal.showLoading();
          }
        },
        customClass: {
          container: "swal2-style",
        },
        title: "Please wait... Reject customer request is sending ",
      });
    }
  },

  rejectCustomer: async (payload: RejectCustomer.Params) => {
   const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
   const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);
    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });
    const remoteRejectCustomer: RejectCustomer = new RemoteRejectCustomer(
      `${BASE_URL}${Endpoints.REJECT_CUSTOMER}`,

      axiosHttpClient
    );
    get().handleRejectLoading(true);
    let response = await remoteRejectCustomer.update(payload);
    if (response.success) return response;
  },
});
